import React from 'react';
import { PriceAlert } from '../types';

interface AlertContextMenuProps {
  alert: PriceAlert;
  isVisible: boolean;
  onClose: () => void;
  onAddToWatchlist: (symbol: string, instType: string) => void;
  isWatched?: boolean;
  onAddToBlacklist?: (symbol: string) => void;
  isBlacklisted?: boolean;
  onRequestAIAnalysis?: (symbol: string) => void;
}

const AlertContextMenu: React.FC<AlertContextMenuProps> = ({
  alert,
  isVisible,
  onClose,
  onAddToWatchlist,
  isWatched = false,
  onAddToBlacklist,
  isBlacklisted = false,
  onRequestAIAnalysis,
}) => {
  if (!isVisible) return null;

  const handleAddToWatchlist = () => {
    const instType = alert.instType ?? 'SPOT';
    onAddToWatchlist(alert.symbol, instType);
    onClose();
  };

  const handleAddToBlacklist = () => {
    if (!onAddToBlacklist) return;
    onAddToBlacklist(alert.symbol);
    onClose();
  };

  const handleRequestAIAnalysis = () => {
    if (!onRequestAIAnalysis) return;
    onRequestAIAnalysis(alert.symbol);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60]">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute left-1/2 top-1/3 -translate-x-1/2 -translate-y-1/3 w-full max-w-xs">
        <div className="relative rounded-xl border border-white/20 bg-gradient-to-br from-purple-900/95 via-blue-900/95 to-indigo-900/95 shadow-2xl overflow-hidden backdrop-blur-sm">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-tr from-cyan-500/10 via-transparent to-purple-500/10" />
            <div className="absolute top-1/3 left-1/4 w-48 h-48 bg-cyan-400/10 rounded-full blur-3xl" />
            <div className="absolute bottom-1/4 right-1/4 w-48 h-48 bg-purple-400/10 rounded-full blur-3xl" />
          </div>
          <div className="relative z-10">
            <div className="px-4 py-3 border-b border-white/10">
              <h3 className="text-sm font-semibold text-white text-center tracking-wide">操作菜单</h3>
            </div>
            <div className="p-4 space-y-3">
              <div className="text-xs text-white/70 text-center">
                <div className="font-medium text-white text-sm">{alert.symbol}</div>
                <div className="text-[11px] text-white/50">
                  {alert.instType} • {alert.timeFrame}
                </div>
              </div>
              <button
                onClick={handleAddToWatchlist}
                disabled={isWatched}
                className={`w-full px-4 py-2.5 rounded-lg text-center text-white transition-all duration-200 ${
                  isWatched
                    ? 'bg-white/5 text-white/40 cursor-not-allowed'
                    : 'bg-blue-500/20 hover:bg-blue-500/30 border border-blue-400/30'
                }`}
              >
                <span className="text-sm">{isWatched ? '已关注' : '关注该币种'}</span>
              </button>
              {onRequestAIAnalysis && (
                <button
                  onClick={handleRequestAIAnalysis}
                  className="w-full px-4 py-2.5 rounded-lg text-center text-white transition-all duration-200 bg-purple-500/20 hover:bg-purple-500/30 border border-purple-400/30"
                >
                  <span className="text-sm">🤖 AI分析</span>
                </button>
              )}
              {onAddToBlacklist && (
                <button
                  onClick={handleAddToBlacklist}
                  disabled={isBlacklisted}
                  className={`w-full px-4 py-2.5 rounded-lg text-center text-white transition-all duration-200 ${
                    isBlacklisted
                      ? 'bg-white/5 text-white/40 cursor-not-allowed'
                      : 'bg-red-500/20 hover:bg-red-500/30 border border-red-400/30'
                  }`}
                >
                  <span className="text-sm">{isBlacklisted ? '已在黑名单' : '加入黑名单'}</span>
                </button>
              )}
              <button
                onClick={onClose}
                className="w-full px-4 py-2.5 rounded-lg text-sm text-white/80 bg-white/10 hover:bg-white/15 transition-colors text-center border border-white/10"
              >
                取消
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertContextMenu;
